const serviceReport = [
    {
        path: '/BpoCallRecord',
        name: 'BpoCallRecord',
        component: () => import(/* webpackChunkName: "BpoCallRecord" */ '@/views/serviceBI/BpoCallRecord/index.vue'),
        meta: {
            title: '外呼通话记录',
            keepAlive: true
        }
    },
    {
        path: '/HqQueueTrafficReport',
        name: 'HqQueueTrafficReport',
        component: () => import(/* webpackChunkName: "HqQueueTrafficReport" */ '@/views/serviceBI/HqQueueTrafficReport/HqQueueTrafficReport.vue'),
        meta: {
            title: '队列话务报表',
            keepAlive: true
        }
    },
    {
        path: '/HqCallInboundReport',
        name: 'HqCallInboundReport',
        component: () => import(/* webpackChunkName: "HqCallInboundReport" */ '@/views/serviceBI/HqCallInboundReport/HqCallInboundReport.vue'),
        meta: {
            title: '话务呼入报表',
            keepAlive: true
        }
    },
    {
        path: '/HqTrafficReport',
        name: 'HqTrafficReport',
        component: () => import(/* webpackChunkName: "HqTrafficReport" */ '@/views/serviceBI/HqTrafficReport/HqTrafficReport.vue'),
        meta: {
            title: '话务综合报表',
            keepAlive: true
        }
    },
    {
        path: '/TotalCallRecording',
        name: 'TotalCallRecording',
        component: () => import(/* webpackChunkName: "TotalCallRecording" */ '@/views/serviceBI/CallRecording/index.vue'),
        meta: {
            title: '通话录音',
            keepAlive: true
        }
    },
    {
        path: '/HqWaybillRepeatCall',
        name: 'HqWaybillRepeatCall',
        component: () => import(/* webpackChunkName: "WaybillRepeatCall" */ '@/views/serviceBI/HqWaybillRepeatCall/HqWaybillRepeatCall.vue'),
        meta: {
            title: '运单重复来电',
            keepAlive: true
        }
    },
    {
        path: '/HqRepeatedCallsDen',
        name: 'HqRepeatedCallsDen',
        component: () => import(/* webpackChunkName: "HqRepeatedCallsDen" */ '@/views/serviceBI/HqRepeatedCallsDen/HqRepeatedCallsDen.vue'),
        meta: {
            title: '重复来电分母',
            keepAlive: true
        }
    },
    {
        path: '/HqRepeatedCalls',
        name: 'HqRepeatedCalls',
        component: () => import(/* webpackChunkName: "HqRepeatedCalls" */ '@/views/serviceBI/HqRepeatedCalls/HqRepeatedCalls.vue'),
        meta: {
            title: '重复来电分子',
            keepAlive: true
        }
    },
    {
        path: '/HqOperationLog',
        name: 'HqOperationLog',
        component: () => import(/* webpackChunkName: "HqOperationLog" */ '@/views/serviceBI/HqOperationLog/HqOperationLog.vue'),
        meta: {
            title: '坐席操作日志',
            keepAlive: true
        }
    },
    {
        path: '/AgentConnectionRateReport',
        name: 'AgentConnectionRateReport',
        component: () => import(/* webpackChunkName: "AgentConnectionRateReport" */ '@/views/serviceBI/AgentConnectionRateReport/AgentConnectionRateReport.vue'),
        meta: {
            title: '坐席接通率报表',
            keepAlive: true
        }
    },
    {
        path: '/HqStatusReport',
        name: 'HqStatusReport',
        component: () => import(/* webpackChunkName: "HqStatusReport" */ '@/views/serviceBI/HqStatusReport/HqStatusReport.vue'),
        meta: {
            title: '坐席状态报表',
            keepAlive: true
        }
    },
    {
        path: '/HqStatusQuery',
        name: 'HqStatusQuery',
        component: () => import(/* webpackChunkName: "HqStatusQuery" */ '@/views/serviceBI/HqStatusQuery/HqStatusQuery.vue'),
        meta: {
            title: '坐席状态查询',
            keepAlive: true
        }
    }
]
export default serviceReport
